// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GD5F","icon":"styles_icon__3viUg"};